module.exports = __webpack_public_path__ + "static/img/power-pole-mk-3_256.bf7c380.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/power-pole-mk-3_256.png
// module id = OtbO
// module chunks = 0